import { Maybe } from '@aibees/shared/definition';
import { SuggestionSearchBarOptionBase } from './types';
import { getNestedValue } from '@aibees/shared/utils';

export function ensureArray<T>(value: T | T[]): T[] {
  if (Array.isArray(value)) {
    return value;
  }
  if (value && typeof value === 'object') {
    return [value];
  }
  return [];
}

export function combineValuesAndSearchKey<
  T extends SuggestionSearchBarOptionBase
>(value: T[], searchKey: Maybe<string>, ignoreSearchKey: boolean = false) {
  if (!value.length && !searchKey?.length) return null;

  const v = value ? (value as T[]) : [];
  if (searchKey && !!searchKey?.length && !ignoreSearchKey) {
    v.push({
      id: searchKey,
      value: searchKey,
      label: searchKey,
      description: searchKey,
    } as T);
  }

  return v.length ? v : null;
}

export const mapToSuggestionOption = <T extends Record<string, any>>(
  data: T,
  idKey: string,
  labelKey: string,
  valueKey: string,
  descriptionKey: string,
  logoKey: string
): SuggestionSearchBarOptionBase => {
  return {
    canSimilaritySearch: true,
    id: getNestedValue(data, idKey),
    label: getNestedValue(data, labelKey),
    value: getNestedValue(data, valueKey),
    description: getNestedValue(data, descriptionKey),
    logo: getNestedValue(data, logoKey),
  };
};
